<template>
  <div class="font-16 pb-0" :class="noPadding ? '' : 'px-13 py-9'">
    <p>
      Rent Protection covers you for up to £2,500 per month, until the tenant is
      evicted, as long as there is a live policy in place. This protects you
      against rent arrears due from a tenant under the tenancy agreement. It
      also provides tenant eviction cover, up to £100,000. This is for legal
      costs and disbursements incurred in evicting a tenant from the property,
      subject to certain conditions.
    </p>

    <p class="mt-4">
      Vacant possession cover is also provided if your property is in need of
      repairs to allow it to be re-let. You will receive 50% of the monthly rent
      for up to 3 months, or until the property is re-let, whichever is the
      sooner.
    </p>

    <p class="font-weight-bold text-uppercase mt-8">
      Examples of what's <u>not</u> covered:
    </p>
    <ul>
      <li>
        Claims where rent is not 30 days in arrears from the rent due date
      </li>
      <li>Claims reported after 60 days from the rent due date</li>
      <li>
        Claims occurring in the first 90 days of cover, if the tenancy agreement
        started before the period of cover unless comparable cover was held with
        no break
      </li>
    </ul>

    <p class="mt-4">
      Please see the policy terms and conditions for further information on our
      rent protection cover. These can be found on our website here:
      <a
        href="https://www.paymentshield.co.uk/types-of-cover/landlords-insurance"
        target="_blank"
      >
        Paymentshield | Landlords Insurance
        <v-icon small class="ml-1">mdi-open-in-new</v-icon>
      </a>
    </p>
    <div class="d-flex justify-center">
      <BaseButton
        depressed
        text="OK"
        rounded
        width="100%"
        max-width="420"
        height="60"
        dense
        :color="'psorange'"
        class="font-weight-bold font-20"
        @click="$emit('click:hideDialog')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogContentWhatsIncludedRentProtection",
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
};
</script>

<style lang="scss" scoped></style>
